module.exports = __webpack_public_path__ + "img/logo_square_blue_sm.18d15a41.png";